/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateExerciseLanguageDto
 */
export interface CreateExerciseLanguageDto {

    /**
     * @type {string}
     * @memberof CreateExerciseLanguageDto
     */
    value: CreateExerciseLanguageDtoValueEnum;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateExerciseLanguageDto
     */
    exercise: JoinEntityDto;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateExerciseLanguageDtoValueEnum {
    IT = 'IT',
    EN = 'EN'
}

